export default __webpack_public_path__ + "static/media/VA.a3f703fd.svg";